module.exports = __webpack_public_path__ + "img/symbol_3.2cc3fc08.png";